import { createAction, props } from '@ngrx/store';
import { GetTemporaryTransactionDTO, CartTotalQuantityDTO, CartTotalPriceDTO } from '@signature-it/ngx-catalogue/models';
import { CodescDTO } from '@signature-it/ngx-generic/models';


export const ADD_TO_CART = '[Cart] ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = '[Cart] ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_FAILURE = '[Cart] ADD_TO_CART_FAILURE';
export const GET_CART = '[Cart] GET_CART';
export const GOT_CART_SUCCESS = '[Cart] GOT_CART_SUCCESS';
export const GOT_CART_FAILURE = '[Cart] GOT_CART_FAILURE';
export const GET_ITEMS_QUANTITY = '[Cart] GET_ITEMS_QUANTITY';
export const GOT_ITEMS_QUANTITY_SUCCESS = '[Cart] GOT_ITEMS_QUANTITY_SUCCESS';
export const GOT_ITEMS_QUANTITY_FAILURE = '[Cart] GOT_ITEMS_QUANTITY_FAILURE';
export const REMOVE_ITEM = '[Cart] REMOVE_ITEM';
export const REMOVE_ITEM_SUCCESS = '[Cart] REMOVE_ITEM_SUCCESS';
export const REMOVE_ITEM_FAILURE = '[Cart] REMOVE_ITEM_FAILURE';
export const REMOVE_ALL_ITEMS = '[Cart] REMOVE_ALL_ITEMS';
export const REMOVE_ALL_ITEMS_SUCCESS = '[Cart] REMOVE_ALL_ITEMS_SUCCESS';
export const REMOVE_ALL_ITEMS_FAILURE = '[Cart] REMOVE_ALL_ITEMS_FAILURE';
export const GET_TOTAL_PRICE = '[Cart] GET_TOTAL_PRICE';
export const TOTAL_PRICE_FAILURE = '[Cart] TOTAL_PRICE_FAILURE';
export const GOT_TOTAL_PRICE_SUCCESS = '[Cart] GOT_TOTAL_PRICE_SUCCESS';
export const GOT_TOTAL_PRICE_FAILURE = '[Cart] GOT_TOTAL_PRICE_FAILURE';
export const CHECKOUT = '[Cart] CHECKOUT';
export const CHECKOUT_SUCCESS = '[Cart] CHECKOUT_SUCCESS';
export const CHECKOUT_FAILURE = '[Cart] CHECKOUT_FAILURE';
export const UPDATE_ALL_QUANTITIES = '[Cart] UPDATE_ALL_QUANTITIES';
export const ADD_TO_CART_CLOSE_MODAL = '[Cart] ADD_TO_CART_CLOSE_MODAL';
export const REDIRECT_LINK_DONE = '[Cart] REDIRECT_LINK_DONE';
export const ADD_TO_CART_CLOSE_ERROR = '[Cart] ADD_TO_CART_CLOSE_ERROR';
export const SKIP_MODAL_AFTER_ADD_TO_CART = '[Cart] SKIP_MODAL_AFTER_ADD_TO_CART';
export const GET_SHIPPINIG_METHOD = '[Cart] GET_SHIPPINIG_METHOD';
export const GOT_SHIPPINIG_METHOD_SUCCESS = '[Cart] GOT_SHIPPINIG_METHOD_SUCCESS';
export const GOT_SHIPPINIG_METHOD_FAILURE = '[Cart] GOT_SHIPPINIG_METHOD_FAILURE';

export const addToCart = createAction(ADD_TO_CART, (payload, options = {}) => {return  {payload, options}});
export const addToCartSuccess = createAction(ADD_TO_CART_SUCCESS, (payload, options) => {
    return { payload, options }
});
export const addToCartFailure = createAction(ADD_TO_CART_FAILURE, props<{ error }>());
export const getCart = createAction(GET_CART);
export const gotCartSuccess = createAction(GOT_CART_SUCCESS, (payload: GetTemporaryTransactionDTO) => payload);
export const gotCartFailure = createAction(GOT_CART_FAILURE, props<{ error }>());
export const getItemsQuantity = createAction(GET_ITEMS_QUANTITY);
export const gotItemsQuantitySuccess = createAction(GOT_ITEMS_QUANTITY_SUCCESS, (payload : CartTotalQuantityDTO) => payload);
export const gotItemsQuantityFailure = createAction(GOT_ITEMS_QUANTITY_FAILURE, props<{ error }>());
export const removeItem = createAction(REMOVE_ITEM, (payload) => { return {payload}});
export const removeItemSuccess = createAction(REMOVE_ITEM_SUCCESS, props<{ cart, quantity, cartProductIds }>());
export const removeItemFailure = createAction(REMOVE_ITEM_FAILURE, props<{ error }>());
export const removeAllItems = createAction(REMOVE_ALL_ITEMS);
export const removeAllItemsSuccess = createAction(REMOVE_ALL_ITEMS_SUCCESS, props<{ cart }>());
export const removeAllItemsFailure = createAction(REMOVE_ALL_ITEMS_FAILURE, props<{ error }>());
export const getTotalPrice = createAction(GET_TOTAL_PRICE, (removeDelivery?, formCheckout?) => {
    return {
        removeDelivery, formCheckout
    }
});

export const totalPriceFailure = createAction(TOTAL_PRICE_FAILURE, props<{ error }>());
export const gotTotalPriceSuccess = createAction(GOT_TOTAL_PRICE_SUCCESS, (payload : CartTotalPriceDTO) => payload);
export const gotTotalPriceFailure = createAction(GOT_TOTAL_PRICE_FAILURE, props<{ error }>());
export const checkout = createAction(CHECKOUT, (payload) =>  { return  { payload } });
export const checkoutSuccess = createAction(CHECKOUT_SUCCESS, props<{ cart }>());
export const checkoutFailure = createAction(CHECKOUT_FAILURE, props<{ error }>());
export const updateAllQuantities = createAction(UPDATE_ALL_QUANTITIES);
export const addToCartCloseModal = createAction(ADD_TO_CART_CLOSE_MODAL);
export const redirectLinkDone = createAction(REDIRECT_LINK_DONE);
export const addToCartCloseFailure = createAction(ADD_TO_CART_CLOSE_ERROR);
export const skipModalAfterAddToCart = createAction(SKIP_MODAL_AFTER_ADD_TO_CART, (payload) => payload);
export const getShippingMethods = createAction(GET_SHIPPINIG_METHOD);
export const gotShippingMethodsSuccess = createAction(GOT_SHIPPINIG_METHOD_SUCCESS, (payload: CodescDTO[]) =>  { return  { payload } });
export const gotShippingMethodsFailure = createAction(GOT_SHIPPINIG_METHOD_FAILURE, props<{ error }>());

